import styled from 'styled-components'
import { white } from '@/theme/colors'
import { radii, media } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'

export const FilterBar = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	color: ${white};
	/* Push the date controls (and the Back link after them) to the right of the nav. */
	margin-left: auto;

	${media.phone} {
		gap: 8px;
		flex-wrap: wrap;
	}
`

export const Presets = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`

export const PresetButton = styled.button<{ $active?: boolean }>`
	font: inherit;
	font-size: ${fontSizes.caption};
	font-weight: ${({ $active }) => ($active ? 700 : 500)};
	padding: 4px 10px;
	border-radius: ${radii.small};
	cursor: pointer;
	color: ${white};
	border: 1px solid ${({ $active }) => ($active ? white : `${white}66`)};
	background-color: ${({ $active }) =>
		$active ? `${white}38` : `${white}14`};

	&:hover {
		border-color: ${white};
	}
`

export const FilterLabel = styled.label`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: ${fontSizes.small};
	font-weight: 500;
	opacity: 0.9;
`

export const DateInput = styled.input`
	font: inherit;
	font-size: ${fontSizes.small};
	padding: 4px 8px;
	border: 1px solid ${white}66;
	border-radius: ${radii.small};
	background-color: ${white}1f;
	color: ${white};
	color-scheme: dark;

	&:focus {
		outline: none;
		border-color: ${white};
	}
`
